import type { ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";
import { cn } from "../lib/utils";
import { tour } from "../lib/tour";
import { Footer } from "./footer";

interface LayoutProps {
  children: ReactNode;
  className?: string;
}

export function Layout({ children, className }: LayoutProps) {
  return (
    <div className={cn("site-layout", className)}>
      {children}
      <Footer />

      <div className="mobile-support">
        <a
          href={tour.fundraiserUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="button button-primary"
        >
          Support the {tour.year} tour <ArrowUpRight aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}
